/**
 * Central chat UI state. Single source of truth for tab, filter, and current conversation.
 */

export const ChatState = {
  currentConversationId: null,
  currentFilter: 'all',
  currentTab: 'first',
  pendingNewGroupCategory: 'city',
  notificationSettings: {
    allow_desktop_notifications: true,
    notification_sound: true,
    email_notifications: true,
    notification_volume: 0.5
  },
  /** Cached conversations from last fetch – used for instant tab/filter switches */
  cachedConversations: null,
  /** Cached participants per conversation for @mentions – keyed by conversation ID */
  conversationParticipants: {},

  resetOnPanelOpen() {
    this.currentConversationId = null;
    this.currentFilter = 'all';
    this.currentTab = 'first';
    this.cachedConversations = null;
    this.conversationParticipants = {};
  },

  clearCache() {
    this.cachedConversations = null;
  }
};
